export default {
    'delete-request': 'Delete request',
    'reject': 'Reject',
    'accept': 'Accept',
    'this-request': 'this request',
    'n-accept': 'accept',
    'n-reject': 'reject',
    'confirm-acceptance': 'Confirm acceptance',
    'confirm-rejection': 'Confirm rejection'
}